
import s from './index.module.scss';
import i2 from './i2.module.scss';
import { loaderPostFetch, csAmount } from './util';

import Notif from '../../components/notif';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import { Entry } from './Statements';
import { useState, useEffect } from 'react';
import DashboardPage7 from './pages/t7/index';


export async function itloader({ params }) {
  const formData = new FormData();
  formData.append('getinstituition', 'getinstituition');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }

  const res = await loaderPostFetch(`api/users.php`, formData);

  const formData2 = new FormData();
  formData2.append('getstatement2', 'getstatement2');
  if (tok != null) {
    formData2.append('token', tok);
  }
  const res2 = await loaderPostFetch(`api/users.php`, formData2);


  const formData3 = new FormData();
  formData3.append('pincheck', 'pincheck');
  if (tok != null) {
    formData3.append('token', tok);
  }
  const pincheck = await loaderPostFetch(`api/users.php`, formData3); 

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...res2, ...res, ...pincheck };
}


export default function DashboardIndex() {

	return (<DashboardPage7 />);

}

export const DashboardR={
      index: true,
      element: <DashboardIndex />,
      loader: itloader,
    }